import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

interface EmployeeProtectedRouteProps {
  children: React.ReactNode;
}

const EmployeeProtectedRoute: React.FC<EmployeeProtectedRouteProps> = ({ children }) => {
  const { user, loading, isEmployee, employeeAccessLevel } = useAuth();

  // Return null while loading - GlobalLayout is already showing navbar/sidebar
  if (loading) {
    return null;
  }

  if (!user) {
    // Not logged in, redirect to sign-in page
    return <Navigate to="/auth" replace />;
  }

  if (!isEmployee) {
    // Logged in but not an employee, redirect to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  if (employeeAccessLevel === 'admin') {
    // Admin employees access the main dashboard, not the employee portal
    return <Navigate to="/dashboard" replace />;
  }

  // User is logged in and is a staff employee, render the employee portal
  return <>{children}</>;
};

export default EmployeeProtectedRoute;
